var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3803 25.3333C5.22439 25.3333 2.66602 22.8051 2.66602 19.6863C2.66602 16.5675 5.22439 14.0392 8.3803 14.0392C8.75913 14.0392 9.12935 14.0756 9.48756 14.1452M19.174 10.7029C19.9683 10.4255 20.8231 10.2745 21.7136 10.2745C22.5865 10.2745 23.4251 10.4196 24.2061 10.6866M9.48756 14.1452C9.1821 13.3304 9.01522 12.4492 9.01522 11.5294C9.01522 7.37103 12.4264 4 16.6343 4C20.5539 4 23.7822 6.92495 24.2061 10.6866M9.48756 14.1452C10.2401 14.2912 10.9397 14.5832 11.5549 14.9901M24.2061 10.6866C27.19 11.707 29.3327 14.5082 29.3327 17.8039C29.3327 21.4133 26.7628 24.4294 23.3327 25.163",
    stroke: "#313131",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0007 21.3335V29.3335M16.0007 21.3335L18.6673 24.0002M16.0007 21.3335L13.334 24.0002",
    stroke: "#313131",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/UploadIcon.af80a8c3095d5a57e07042c8a75a53c3.svg";
export { ForwardRef as ReactComponent };